// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2":"31e52899c3dea3eb","720":"27349c22f753d3f3","892":"04d25178525827c5"}[chunkId] + ".js";
};